module.exports = __webpack_public_path__ + "img/kazakhstan.fb346a50.png";